import { customerServiceSurveyTemplate } from "./customerFeedback/customerServiceSurveyTemplate";
import { netPromoterScoreSurveyTemplate } from "./customerFeedback/netPromoterScoreSurveyTemplate";
import { customerSatisfactionSurveyTemplate } from "./customerFeedback/customerSatisfactionSurveyTemplate";
import { employeeEngagementSurveyTemplate } from "./customerFeedback/employeeEngagementSurveyTemplate";
import { brandAwarenessSurveyTemplate } from "./customerFeedback/brandAwarenessSurveyTemplate";
import { generalEventFeedbackSurveyTemplate } from "./customerFeedback/generalEventFeedbackSurveyTemplate";
import { eventRegistrationFormSurveyTemplate } from "./customerFeedback/eventRegistrationFormSurveyTemplate";
import { purchaseSatisfactionSurveyTemplate } from "./customerFeedback/purchaseSatisfactionSurveyTemplate";
import { customerEffortScoreSurveyTemplate } from "./customerFeedback/customerEffortScoreSurveyTemplate";
import { marketSizingSurveyTemplate } from "./marketResearch/marketSizingSurveyTemplate";

export const surveyTemplates = [
    customerServiceSurveyTemplate,
    netPromoterScoreSurveyTemplate,
    customerSatisfactionSurveyTemplate,
    employeeEngagementSurveyTemplate,
    brandAwarenessSurveyTemplate,
    generalEventFeedbackSurveyTemplate,
    eventRegistrationFormSurveyTemplate,
    purchaseSatisfactionSurveyTemplate,
    customerEffortScoreSurveyTemplate,
    marketSizingSurveyTemplate,
];
